import React, { useRef, useState } from 'react';
import TextInput from "../../components/Formik/TextInput";
import { X } from "react-feather";
import { deleteMAVFile, uploadMAVFile } from "../../services/api/admin";

const PresenterForm = ({ index, formik, removePresenter, onImageDelete }) => {
    const {touched, errors, setFieldValue} = formik;
    const inputRef = useRef();
    const [isLoading, setLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState(
        formik.values.presenters[index] && formik.values.presenters[index].photo
            ? formik.values.presenters[index].photo.preview
            : null
    );

    const handleFileSelect = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setLoading(true);
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await uploadMAVFile(formData);
            await setFieldValue(`presenters[${index}].photo`, response.data);
            setImagePreview(response.data.preview);
            setLoading(false);
        } catch (error) {
            console.error('Error uploading file:', error);
            setLoading(false);
        }
    };

    const deleteImage = async () => {
        try {
            const presenter = formik.values.presenters[index];
            const selectedFile = formik.values.presenters[index].photo;
            if (selectedFile) {
                await deleteMAVFile(selectedFile.location);
                await setFieldValue(`presenters[${index}].photo`, null);
                presenter.photo = null;
                await onImageDelete("presenters", {index: index, presenter: presenter});
                setImagePreview(null);
            }
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <div className="sl-mt-2 sl-mb-4 sl-p-4 sl-gap-4 sl-border-1 sl-border-radius-8 sl-shadow-xs sl-width-50 sl-relative">
            <div className={`sl-mt-2`}>
                <TextInput
                    formik={formik}
                    label={`Presenter Name`}
                    name={`presenters[${index}].name`}
                />
            </div>
            {touched['presenters'] && touched['presenters'][index]['name']
                && errors['presenters'] && errors['presenters'][index] && errors['presenters'][index]['name'] &&
                <span className="sl-text-error-500 sl-mt-2 sl-font sl-text-sm sl-font">{errors['presenters'][index]['name']}</span>}

            <div className={`sl-mt-4`}>
                <TextInput
                    formik={formik}
                    label={`Presenter Title`}
                    name={`presenters[${index}].title`}
                />
            </div>
            {touched['presenters'] && touched['presenters'][index]['title']
                && errors['presenters'] && errors['presenters'][index] && errors['presenters'][index]['title'] &&
                <span className="sl-text-error-500 sl-mt-2 sl-font sl-text-sm sl-font">{errors['presenters'][index]['title']}</span>}

            <div className="sl-mt-4 sl-width-100 sl-text-left sl-flex sl-flex-col">
                <span className="sl-font sl-font-medium sl-text-sm sl-text-gray-700">Profile Photo</span>
                <div className="sl-mt-2 sl-w-fill-available sl-flex sl-flex-row sl-relative sl-flex-wrap">
                    {imagePreview && (
                        <div className="sl-relative sl-m-2">
                            <img
                                className="sl-m-15 sl-ml-0 sl-mt-"
                                width={100}
                                height={100}
                                style={{objectFit: 'contain'}}
                                src={imagePreview}
                                alt="Presenter"
                            />
                            <X className="sl-absolute sl-top-0 sl-right-0 sl-cursor-pointer sl-m-1"
                               onClick={deleteImage}/>
                        </div>
                    )}
                </div>
                <input
                    ref={inputRef}
                    accept=".png,.jpg,.jpeg"
                    name={`presenters[${index}]`.photo}
                    onChange={handleFileSelect}
                    className="sl-hidden"
                    type="file"
                />
                <button
                    disabled={isLoading}
                    onClick={() => inputRef.current.click()}
                    className="sl-btn sl-btn-primary sl-btn-md sl-pl-20 sl-pr-20 sl-font sl-w-fit-content">
                    {!isLoading && 'Select'}
                    {isLoading && <div className="sl-loader sl-m-auto "/>}
                </button>
            </div>

            <div className="sl-absolute sl-right-2 sl-top-2 sl-cursor-pointer">
                <X onClick={() => removePresenter(index)}/>
            </div>
        </div>
    );
};

export default PresenterForm;